import { Auth } from 'aws-amplify'
import axios, { AxiosHeaders, AxiosResponse, CreateAxiosDefaults, InternalAxiosRequestConfig } from 'axios'

/**
 * Small helper to get the lang attribute passed to API calls
 * We check explicitly for supported languages as otherwise an API call might fail
 */
const DEFAULT_API_LANG = 'en' as const
// No need to add 'uk' here; it falls back to 'en', which is the correct API language for the UK.
const supportedLanguagesAPI = ['en', 'au', 'us', 'fr', 'de', 'it', 'nl', 'es'] as const
type SupportedLanguagesAPI = typeof supportedLanguagesAPI[number]

export const languageCodeAPI = (locale?: string) => {
  if (locale == undefined) return DEFAULT_API_LANG
  return supportedLanguagesAPI.includes(locale as SupportedLanguagesAPI) ? locale : DEFAULT_API_LANG
}

const baseConfig: CreateAxiosDefaults = {
  withCredentials: true,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  }
}
const baseConfigMultipart: CreateAxiosDefaults = {
  withCredentials: true,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  }
}

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_V2_PUBLIC,
  ...baseConfig,
  headers: {
    ...baseConfig.headers,
    'x-api-key': '67hNk6y7sT2yiZ5xK69C037Axz0Tbs6w85Wg6EvA'
  }
})

const getAuthorizationToken = async () => {
  const session = await Auth.currentSession()
  return session.getIdToken().getJwtToken()
}

const recreateConfig = async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
  const headers = new AxiosHeaders(config.headers)
  headers.set('Authorization', await getAuthorizationToken())
  return {
    ...config,
    headers: headers
  }
}

const handleResponseError = async (error) => {
  const config = error?.config
  if (error?.response?.status === 401 && !config?.sent) {
    return axios(await recreateConfig(config))
  }
  return Promise.reject(error)
}

export const protectedApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_V2_PRIVATE,
  ...baseConfig,
  headers: {
    ...baseConfig.headers
  }
})

protectedApi.interceptors.request.use(
  (config) => recreateConfig(config),
  (error) => Promise.reject(error)
)

protectedApi.interceptors.response.use((response: AxiosResponse): AxiosResponse => response, handleResponseError)
